<template>
  <form>
    <fieldset class="fieldset">
      <legend>{{ 'Filter'|t }}</legend>
      <div class="expanded row small-up-1 medium-up-2 large-up-4">
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="tld" class="middle">{{ 'TLD'|t }}</label></div>
            <div class="column"><input id="tld" class="text-center" type="text" v-model="filter.tld"></div>
          </div>
        </div>
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="country" class="middle">{{ 'Country'|t }}</label></div>
            <div class="column"><input id="country" class="text-center" type="text" v-model="filter.country" maxlength="2"></div>
          </div>
        </div>
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="expol" class="middle">{{ 'Expiration policy'|t }}</label></div>
            <div class="column">
              <select id="expol" v-model="filter.expiration_policy">
                <option value=""></option>
                <option value="autorenew">{{ 'Auto-renew'|t }}</option>
                <option value="rgp">{{ 'RGP'|t }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="small-3 columns">
          <div class="expanded button-group">
            <button class="hollow success button" @click.prevent="submitForm()">{{ 'Submit'|t }}</button>
            <button class="hollow primary button" @click.prevent="clearForm()">{{ 'Clear'|t }}</button>
          </div>
        </div>
      </div>
      <a @click="toggleOpen"><i class="icon icon-equalizer2"></i> {{'Toggle filters'|t }}</a>
    </fieldset>

    <div class="callout expanded-filters" v-if="is_open">
      <table class="unstriped hover">
        <thead>
          <tr>
            <th>{{ 'Option'|t }}</th>
            <th>{{ 'Ignore'|t }}</th>
            <th>{{ 'Yes'|t }}</th>
            <th>{{ 'No'|t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="opt in getOptionsList()" :key="opt.field">
            <td>{{ opt.label|t }}</td>
            <td>
              <div class="switch">
                <input class="switch-input" :id="opt.field + '-switch'" v-model="filter[opt.field]" type="radio" value="">
                <label class="switch-paddle" :for="opt.field + '-switch'">
                  <span class="show-for-sr">{{ 'Ignore'|t }}</span>
                </label>
              </div>
            </td>
            <td>
              <div class="switch">
                <input class="switch-input" :id="opt.field + '-switch-yes'" v-model="filter[opt.field]" type="radio" value="y">
                <label class="switch-paddle" :for="opt.field + '-switch-yes'">
                  <span class="show-for-sr">{{ 'Yes'|t }}</span>
                </label>
              </div>
            </td>
            <td>
              <div class="switch">
                <input class="switch-input" :id="opt.field + '-switch-n'" v-model="filter[opt.field]" type="radio" value="n">
                <label class="switch-paddle" :for="opt.field + '-switch-n'">
                  <span class="show-for-sr">{{ 'No'|t }}</span>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </form>
</template>
<script>
  export default {
    name: 'TLDCollectionFilterForm',
    props: {
      value: {
        type: Object,
        default: () => {
          let props = this.getProps();
          let filter = {};
          for (let i in props) {
            filter[props[i]] = "";
          }
          return filter;
        }
      }
    },
    data() {
      let props = this.getProps();
      let filter = {};
      for (let i in props) {
        filter[props[i]] = this.value.hasOwnProperty(props[i]) ? this.value[props[i]] : "";
      }
      return {
        filter,
        is_open: false
      }
    },
    methods: {
      submitForm() {
        this.$emit('submit', this.massageValues(this.filter));
      },
      clearForm() {
        let props = this.getProps();
        for (let i in props) {
          this.filter[props[i]] = "";
        }
        this.is_open = false;
        this.$emit('reset', this.massageValues(this.filter));
      },
      getOptionsList() {
        return [
          {field: "idn_allowed", label: "Allow IDN"},
          {field: "idnum_required", label: "Required IDNum"},
          {field: "vat_required", label: "Require VAT"},
          {field: "birthdate_required", label: "Require birth date"},
          {field: "confirmation", label: "Require confirmation"},
          {field: "ns_required", label: "Require name servers"},
          {field: "plain_transfer", label: "Allow plain transfer"},
        ]
      },
      toggleOpen() {
        this.is_open = !this.is_open;
      },
      getProps() {
        return [
          "tld",
          "country",
          "idn_allowed",
          "idnum_required",
          "vat_required",
          "birthdate_required",
          "confirmation",
          "ns_required",
          "plain_transfer",
          "expiration_policy"
        ];
      },
      massageValues(values) {
        let cp = JSON.parse(JSON.stringify(values));
        let ops = this.getOptionsList().map(opt => opt.field);
        for (let i in cp) {
          if (ops.indexOf(i) > -1) {
            switch (cp[i]) {
              case "":
                delete cp[i];
                break;
              case "y":
                cp[i] = true;
                break;
              case "n":
                cp[i] = false;
                break;
            }
          }
        }
        return cp;
      }
    },
    watch: {
      filter: {
        deep: true,
        handler(to) {
          this.$emit('change', this.massageValues(to))
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/TLDCollectionFilterForm.vue